/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringFacetValue
 */
export interface StringFacetValue {
    /**
     * 
     * @type {string}
     * @memberof StringFacetValue
     */
    value?: string;
    /**
     * 
     * @type {number}
     * @memberof StringFacetValue
     */
    count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof StringFacetValue
     */
    selected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringFacetValue
     */
    title?: string;
}

/**
 * Check if a given object implements the StringFacetValue interface.
 */
export function instanceOfStringFacetValue(value: object): boolean {
    return true;
}

export function StringFacetValueFromJSON(json: any): StringFacetValue {
    return StringFacetValueFromJSONTyped(json, false);
}

export function StringFacetValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringFacetValue {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'count': json['count'] == null ? undefined : json['count'],
        'selected': json['selected'] == null ? undefined : json['selected'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function StringFacetValueToJSON(value?: StringFacetValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'count': value['count'],
        'selected': value['selected'],
        'title': value['title'],
    };
}

